import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface DottedLogoProps {
  className?: string;
  variant?: 'light' | 'dark';
  opacity?: number;
}
export function DottedLogo({
  className = '',
  variant = 'dark',
  opacity = 0.4
}: DottedLogoProps) {
  const reduceMotion = useReducedMotion();
  return <div className={`absolute pointer-events-none flex items-center justify-center ${className}`} aria-hidden="true" style={{
    opacity
  }} data-id="element-2528" data-mp="3m6lm1qo39otr">
      {/* Outer wrapper applies a soft radial fade so the dots bloom in the center and fade at the edges */}
      <div className="absolute inset-0" style={{
      WebkitMaskImage: 'radial-gradient(circle at center, black 20%, transparent 80%)',
      maskImage: 'radial-gradient(circle at center, black 20%, transparent 80%)'
    }} data-id="element-2529" data-mp="3d4m5t0kweorv">
        <motion.div className="absolute inset-0" animate={reduceMotion ? {} : {
        scale: [1, 1.02, 1],
        opacity: [0.8, 1, 0.8]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-2530" data-mp="whtfeuwf1tb1">
          {/* The dot matrix pattern, clipped to the Giga logo silhouette */}
          <div className={`w-full h-full ${variant === 'dark' ? 'dot-matrix-dark' : 'dot-matrix'}`} style={{
          WebkitMaskImage: "url('https://cdn.magicpatterns.com/uploads/bxQBDjkPJfWx4r7DHyApcd/Vector.png')",
          WebkitMaskSize: 'contain',
          WebkitMaskPosition: 'center',
          WebkitMaskRepeat: 'no-repeat',
          maskImage: "url('https://cdn.magicpatterns.com/uploads/bxQBDjkPJfWx4r7DHyApcd/Vector.png')",
          maskSize: 'contain',
          maskPosition: 'center',
          maskRepeat: 'no-repeat'
        }} data-id="element-2531" data-mp="1n6xmt7iaymw" />
        </motion.div>
      </div>
    </div>;
}